/* DSL Klaviyo profile sync — bij signup of customer-account: identify Klaviyo profile met email + custom props */
(function(){
  if (!window.DSL_CUSTOMER || !window.DSL_CUSTOMER.email) return;
  function sync(){
    if (!window.klaviyo) return;
    try {
      window.klaviyo.identify({
        $email: window.DSL_CUSTOMER.email,
        $first_name: window.DSL_CUSTOMER.first_name || "",
        $last_name: window.DSL_CUSTOMER.last_name || "",
        Wishlist_Count: window.DSL_WISHLIST ? window.DSL_WISHLIST.get().size : 0,
        Total_Spent: window.DSL_CUSTOMER.total_spent || 0,
        Loyalty_Tier: window.DSL_CUSTOMER.tier || "bronze"
      });
    } catch(e){}
  }
  // Wait for Klaviyo to be ready
  if (window.klaviyo) sync();
  else {
    var iv = setInterval(function(){ if (window.klaviyo) { clearInterval(iv); sync(); } }, 500);
    setTimeout(function(){ clearInterval(iv); }, 15000);
  }
})();